import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as moment from 'moment';

import { AuthService } from '../services/auth.service';
import { CheckMotoService } from '../services/check-moto.service';

@Component({
  selector: 'app-checklist-moto-ver',
  templateUrl: './checklist-moto-ver.component.html',
  styleUrls: ['./checklist-moto-ver.component.css'],
	animations: [loadingFade]
})
export class ChecklistMotoVerComponent implements OnInit {
  public loading;
  public submitting = false;
  public justificativa;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  //filtros
  public cliente_id___cliente = null;
  public unidade_id___unidade = null;
  public veiculo_id___veiculo = null;
  public check_moto_turno___periodo = null;
  public check_moto_data___data_i = null;
  public check_moto_data___data_f=  null;
  public especialidade_veiculo_id___veiculo = null;
  public profissional_id___profissional = null;

  public check_moto_id = null;

  constructor(private authSvc: AuthService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private router: Router,
              private checkMotoSvc: CheckMotoService,
              ) { }

  ngOnInit() {
    this.criaForm();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_moto_turno___periodo": { 
                this.check_moto_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_moto_data___data_i": { 
                this.check_moto_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_moto_data___data_f": { 
                this.check_moto_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "especialidade_veiculo_id___veiculo": { 
                this.especialidade_veiculo_id___veiculo = loSplitValor[1];
                 break; 
              }    
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }           
        

				this.check_moto_id = params.id;
				this.checkMotoSvc.getCheckMoto(params.id).then((data: any) => {
          if(data.check_moto_justificativa != null){
            this.justificativa = true;
          }
					this.preencheForm({
            check_moto_id: data.check_moto_id,
            check_moto_data: moment(data.check_moto_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_moto_turno: data.check_moto_turno,
            check_moto_justificativa: data.check_moto_justificativa,
            check_moto_quilometragem: this.mascaraKm(data.check_moto_quilometragem),
            check_moto_combustivel: data.check_moto_combustivel,
            check_moto_oleo_motor: data.check_moto_oleo_motor,
            check_moto_oleo_motor_obs: data.check_moto_oleo_motor_obs,
            check_moto_corrente: data.check_moto_corrente,
            check_moto_corrente_obs: data.check_moto_corrente_obs,
            check_moto_freio: data.check_moto_freio,
            check_moto_freio_obs: data.check_moto_freio_obs,
            check_moto_pneus: data.check_moto_pneus,
            check_moto_pneus_obs: data.check_moto_pneus_obs,
            check_moto_retrovisor_dir: data.check_moto_retrovisor_dir,
            check_moto_retrovisor_dir_obs: data.check_moto_retrovisor_dir_obs,
            check_moto_retrovisor_esq  : data.check_moto_retrovisor_esq,
            check_moto_retrovisor_esq_obs: data.check_moto_retrovisor_esq_obs,
            check_moto_meia_luz: data.check_moto_meia_luz,
            check_moto_meia_luz_obs: data.check_moto_meia_luz_obs,
            check_moto_luz_baixa: data.check_moto_luz_baixa,
            check_moto_luz_baixa_obs: data.check_moto_luz_baixa_obs,
            check_moto_luz_alta: data.check_moto_luz_alta,
            check_moto_luz_alta_obs: data.check_moto_luz_alta_obs,
            check_moto_pisca_direito: data.check_moto_pisca_direito,
            check_moto_pisca_direito_obs: data.check_moto_pisca_direito_obs,
            check_moto_pisca_esquerdo: data.check_moto_pisca_esquerdo, 
            check_moto_pisca_esquerdo_obs: data.check_moto_pisca_esquerdo_obs, 
            check_moto_partida: data.check_moto_partida,
            check_moto_partida_obs: data.check_moto_partida_obs,
            check_moto_luz_freio: data.check_moto_luz_freio,
            check_moto_luz_freio_obs: data.check_moto_luz_freio_obs,
            check_moto_lanterna_tra: data.check_moto_lanterna_tra,
            check_moto_lanterna_tra_obs: data.check_moto_lanterna_tra_obs,
            check_moto_sirene: data.check_moto_sirene,
            check_moto_sirene_obs: data.check_moto_sirene_obs,
            check_moto_buzina: data.check_moto_buzina,
            check_moto_buzina_obs: data.check_moto_buzina_obs,
            check_moto_giroflex: data.check_moto_giroflex,
            check_moto_giroflex_obs: data.check_moto_giroflex_obs,
            check_moto_estrobo: data.check_moto_estrobo,
            check_moto_estrobo_obs: data.check_moto_estrobo_obs,
            check_moto_capacete: data.check_moto_capacete,
            check_moto_capacete_obs: data.check_moto_capacete_obs,
            check_moto_joelheira: data.check_moto_joelheira,
            check_moto_joelheira_obs: data.check_moto_joelheira_obs,
            check_moto_cotoveleira: data.check_moto_cotoveleira,
            check_moto_cotoveleira_obs: data.check_moto_cotoveleira_obs,
            check_moto_luvas: data.check_moto_luvas,
            check_moto_luvas_obs: data.check_moto_luvas_obs,
            check_moto_botas: data.check_moto_botas,
            check_moto_botas_obs: data.check_moto_botas_obs,
            check_moto_colete: data.check_moto_colete,
            check_moto_colete_obs: data.check_moto_colete_obs,
            check_moto_jaqueta: data.check_moto_jaqueta,
            check_moto_jaqueta_obs: data.check_moto_jaqueta_obs,
            check_moto_capa: data.check_moto_capa,
            check_moto_capa_obs: data.check_moto_capa_obs,
            check_moto_documento: data.check_moto_documento,
            check_moto_documento_obs: data.check_moto_documento_obs,
            check_moto_cartao_abastecimento: data.check_moto_cartao_abastecimento,
            check_moto_cartao_abastecimento_obs: data.check_moto_cartao_abastecimento_obs,
            check_moto_gps: data.check_moto_gps,
            check_moto_gps_obs: data.check_moto_gps_obs,
            check_moto_celular: data.check_moto_celular, 
            check_moto_celular_obs: data.check_moto_celular_obs,
            check_moto_registro: data.check_moto_registro,
            mesorregiao: data.cliente.cliente_nome,
            unidade: data.unidade.unidade_nome,
            profissional: data.profissional.profissional_nome,
            veiculo: data.veiculo.veiculo_placa + ' - ' + data.veiculo.veiculo_numero
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
  }

  criaForm(){
    this.formChecklist = this.fb.group({
			check_moto_id: {value: null, disabled: true},
      check_moto_data: {value: null, disabled: true},
      check_moto_turno: {value: null, disabled: true},
      check_moto_justificativa: {value: null, disabled: true},
      check_moto_quilometragem: {value: null, disabled: true},
      check_moto_combustivel: {value: null, disabled: true},
      check_moto_oleo_motor: {value: null, disabled: true},
      check_moto_oleo_motor_obs: {value: null, disabled: true},
      check_moto_corrente: {value: null, disabled: true},
      check_moto_corrente_obs: {value: null, disabled: true},
      check_moto_freio: {value: null, disabled: true},
      check_moto_freio_obs: {value: null, disabled: true},
      check_moto_pneus: {value: null, disabled: true},
      check_moto_pneus_obs: {value: null, disabled: true},
      check_moto_retrovisor_dir: {value: null, disabled: true},
      check_moto_retrovisor_dir_obs: {value: null, disabled: true},
      check_moto_retrovisor_esq  : {value: null, disabled: true},
      check_moto_retrovisor_esq_obs: {value: null, disabled: true},
      check_moto_meia_luz: {value: null, disabled: true},
      check_moto_meia_luz_obs: {value: null, disabled: true},
      check_moto_luz_baixa: {value: null, disabled: true},
      check_moto_luz_baixa_obs: {value: null, disabled: true},
      check_moto_luz_alta: {value: null, disabled: true},
      check_moto_luz_alta_obs: {value: null, disabled: true},
      check_moto_pisca_direito: {value: null, disabled: true},
      check_moto_pisca_direito_obs: {value: null, disabled: true},
      check_moto_pisca_esquerdo: {value: null, disabled: true},
      check_moto_pisca_esquerdo_obs: {value: null, disabled: true},
      check_moto_partida: {value: null, disabled: true},
      check_moto_partida_obs: {value: null, disabled: true},
      check_moto_luz_freio: {value: null, disabled: true},
      check_moto_luz_freio_obs    : {value: null, disabled: true},
      check_moto_lanterna_tra  : {value: null, disabled: true},
      check_moto_lanterna_tra_obs: {value: null, disabled: true},
      check_moto_sirene: {value: null, disabled: true},
      check_moto_sirene_obs: {value: null, disabled: true},
      check_moto_buzina: {value: null, disabled: true},
      check_moto_buzina_obs: {value: null, disabled: true},
      check_moto_giroflex: {value: null, disabled: true},
      check_moto_giroflex_obs: {value: null, disabled: true},
      check_moto_estrobo: {value: null, disabled: true},
      check_moto_estrobo_obs  : {value: null, disabled: true},
      check_moto_capacete: {value: null, disabled: true},
      check_moto_capacete_obs: {value: null, disabled: true},
      check_moto_joelheira: {value: null, disabled: true},
      check_moto_joelheira_obs: {value: null, disabled: true},
      check_moto_cotoveleira: {value: null, disabled: true},
      check_moto_cotoveleira_obs: {value: null, disabled: true},
      check_moto_luvas: {value: null, disabled: true},
      check_moto_luvas_obs: {value: null, disabled: true},
      check_moto_botas: {value: null, disabled: true},
      check_moto_botas_obs: {value: null, disabled: true},
      check_moto_colete: {value: null, disabled: true},
      check_moto_colete_obs   : {value: null, disabled: true},
      check_moto_jaqueta: {value: null, disabled: true},
      check_moto_jaqueta_obs: {value: null, disabled: true},
      check_moto_capa: {value: null, disabled: true},
      check_moto_capa_obs: {value: null, disabled: true},
      check_moto_documento: {value: null, disabled: true},
      check_moto_documento_obs: {value: null, disabled: true},
      check_moto_cartao_abastecimento: {value: null, disabled: true},
      check_moto_cartao_abastecimento_obs: {value: null, disabled: true},
      check_moto_gps: {value: null, disabled: true},
      check_moto_gps_obs: {value: null, disabled: true},
      check_moto_celular: {value: null, disabled: true},
      check_moto_celular_obs: {value: null, disabled: true},
      check_moto_registro:{value: null, disabled: true},
      mesorregiao: {value: null, disabled: true},
      unidade: {value: null, disabled: true},
      profissional: {value: null, disabled: true},
      veiculo: {value: null, disabled: true}
    });
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }

  print(id){
    //let url = location.href.split('#')[0] + '#' +'(print:print/checkmoto/'+ id +')'
    //window.open(url);
    this.router.navigate(['home/checkmotoprint/' + id]);
	}

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_moto_turno___periodo=" + this.check_moto_turno___periodo;
    params += "&check_moto_data___data_i=" + this.check_moto_data___data_i;
    params += "&check_moto_data___data_f=" + this.check_moto_data___data_f;
    params += "&especialidade_veiculo_id___veiculo=" + this.especialidade_veiculo_id___veiculo;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    this.router.navigate(['/home/checkmotofiltro/' + params]);

  }

  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}


		}else{
      return "";
    }

	  }
  
}
